<template>
  <div class="row">
    <div v-if="!load" class="col-md-12">
      <div
        v-if="items.length"
        id="nav-group"
        class="tab-pane fade show active pt-3"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <b-row>
          <b-col md="4" v-for="item in items" :key="item.id">
            <!--begin::Container-->
            <b-card no-body class="card-developer-meetup">
              <div class="bg-light-primary rounded-top text-center">
                <b-img :src="sideImg" alt="Meeting Pic" height="170" />
              </div>
              <b-card-body>
                <!-- metting header -->
                <div class="meetup-header d-flex align-items-center">
                  <div class="meetup-day">
                    <h3 class="mb-0">{{ item.id }}</h3>
                  </div>
                  <div class="my-auto">
                    <b-card-title class="mb-25">
                      {{ item.name }}
                    </b-card-title>
                  </div>
                </div>

                <hr />
                <b-row>
                  <b-button
                    block
                    variant="relief-primary"
                    v-if="checkUser(item)"
                    v-b-modal.modal-period
                    :disabled="!notRegisteredInOtherProgram"
                    @click="itemSelected = item"
                  >
                    التحق الآن
                  </b-button>
                  <b-button block variant="relief-success " disabled v-else>
                    تم ارسال الطلب
                    </b-button
                  >
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
      <!-- /.tab-pane -->
      <div
        v-else
        id="nav-group"
        class="tab-pane fade show active pt-3"
        role="tabpanel"
        aria-labelledby="nav-group-tab"
      >
        <h2>{{ $t("edu_programs.no_edu_programs") }}</h2>
      </div>
      <!-- /.tab-pane -->
    </div>
    <b-spinner v-else type="grow" label="Loading..." class="loading" />
    <b-modal
      id="modal-period"
      cancel-variant="outline-secondary"
      ok-title="التحق"
      ok-only
      centered
      @ok="Join(itemSelected)"
    >
      <b-form>
        <b-form-group>
          <label for="email"> نبدأ من الجزء رقم:</label>
        <select v-model="period"  class="form-control mb-2" >
          <option v-for="index in 30" :key="index">{{ index }}</option>
        </select>
        <b-form-radio v-model="SaveType" :aria-describedby="ariaDescribedby" name="some-radios" value="asc">تنازلي</b-form-radio>
        <b-form-radio v-model="SaveType" :aria-describedby="ariaDescribedby" name="some-radios" value="desc">تصاعدي</b-form-radio>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import QuranProgramsController from "@/Controllers/QuranProgramsController";
import ReadingTypeController from "@/Controllers/ReadingTypeController";
export default {
  name: "QuranProgramsٍtudent",

  data() {
    return {
      SaveType: 1,
      items: [],
      tab: 0,
      load: false,
      sideImg: require("@/assets/images/pages/buldozer.png"),
      systemic: [],
      itemSelected: {},
      period: 1
    };
  },
  async created() {
    this.dataProvider();
  },
  computed: {
    notRegisteredInOtherProgram() {
      return this.systemic.length == 0;
    },
  },
  methods: {
    async Join(item) {
      await new QuranProgramsController().Join({
        readingType: item.id,
        period: this.period,
        SaveType: this.SaveType
      });
      this.dataProvider();
    },
    onChangePage(page) {
      this.params.currentPage = page;
      this.dataProvider();
    },
    async dataProvider() {
      this.load = true;
      this.systemic = await new QuranProgramsController().GetAll({
        filter: "systemic|1",
      });
      const items = await new ReadingTypeController().GetAll();
      this.items = items;
      this.load = false;
    },
    checkUser(item) {
      const index = this.systemic.findIndex((a) => a.reading_type == item.id);

      if (index != -1) {
        return false;
      }
      return true;
    },
  },
};
</script>
